<div class="ui-select" [class.size-s]="size === 's'" [class.invalid]="invalid">
  <p-select
    [options]="options"
    [optionLabel]="optionLabel"
    [optionValue]="optionValue"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [disabled]="disabled"
    [ngModel]="value"
    (onChange)="onSelect($event)"
    appendTo="body"
    styleClass="w-100"
  ></p-select>
</div>
